"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const regulaExpersions_1 = require("./regulaExpersions");
const selectModules_1 = require("./selectModules");
const utility_1 = require("./utility");
exports.solveBetweenParantheses = (input) => {
    let result = input;
    const betweenParantes = selectModules_1.selectParantheses(result);
    if (!betweenParantes) {
        return result;
    }
    betweenParantes.forEach(inp => {
        const resultPhrase = exports.solveMathPhrases(inp);
        result = result.replace(inp, resultPhrase);
    });
    return exports.solveBetweenParantheses(result);
};
exports.solveMathPhrases = (phrase) => {
    let result = exports.solveSevralPositiveAndNegativeSings(phrase);
    result = exports.solvePowerPhrases(result);
    result = exports.solveDivisionPharse(result);
    result = exports.solveMultiplicationPhrase(result);
    result = exports.solveSummationOrSubtractionPhrase(result);
    result = result.replace(/[()]/g, '');
    return result;
};
exports.solveDivisionPharse = (phrase) => {
    const divisionPhrase = selectModules_1.selectDivisionPharse(phrase);
    if (!divisionPhrase) {
        return phrase;
    }
    divisionPhrase.forEach(phr => {
        const _result = exports.convertDivisionToMultiplication(phr);
        phrase = phrase.replace(phr, _result);
    });
    return exports.solveDivisionPharse(phrase);
};
exports.convertDivisionToMultiplication = (phrase) => {
    const _result = 1 / +selectModules_1.selectNumbers(phrase)[0];
    return `*${_result}`;
};
exports.solveMultiplicationPhrase = (phrase) => {
    const multiplicationOrDivisionPhrase = selectModules_1.selectMultiplicationPhrase(phrase);
    if (!multiplicationOrDivisionPhrase) {
        return phrase;
    }
    multiplicationOrDivisionPhrase.forEach(phr => {
        const _result = exports.solveMultiplication(phr);
        phrase = phrase.replace(phr, _result);
    });
    return exports.solveMultiplicationPhrase(phrase);
};
exports.solveSummationOrSubtractionPhrase = (phrase) => {
    const summationOrSubtractionPhrase = selectModules_1.selectSummationOrSubtractionPhrase(phrase);
    if (!summationOrSubtractionPhrase) {
        return phrase;
    }
    summationOrSubtractionPhrase.forEach(phr => {
        const _result = exports.solveSummationOrSubtraction(phr);
        phrase = phrase.replace(phr, _result);
    });
    return exports.solveSummationOrSubtractionPhrase(phrase);
};
exports.solveMultiplication = (phrase) => {
    const numbers = selectModules_1.selectNumbers(phrase);
    const num1 = numbers[0];
    const num2 = numbers[1];
    const result = +num1 * +num2;
    return result >= 0 ? `+${result.toString()}` : result.toString();
};
exports.solveSummationOrSubtraction = (phrase) => {
    const numbers = selectModules_1.selectNumbers(phrase);
    const num1 = numbers[0];
    const num2 = numbers[1];
    const mathOperator = phrase.replace(new RegExp(`(${utility_1.convertSpecialChar(num1)}|${utility_1.convertSpecialChar(num2)})`, 'g'), '');
    const result = mathOperator == regulaExpersions_1.mathSigns.subtraction ? +num1 - +num2 : +num1 + +num2;
    return result >= 0 ? `+${result.toString()}` : result.toString();
};
exports.solveSevralPositiveAndNegativeSings = (phrase) => {
    const regExpPosNeg = /(\-\+)|(\+\-)/g;
    const regExpPosPosOrNegNeg = /(\+\+)|(\-\-)/g;
    if (regExpPosNeg.test(phrase)) {
        phrase.match(regExpPosNeg).forEach(phr => {
            phrase = phrase.replace(phr, '-');
        });
        return exports.solveSevralPositiveAndNegativeSings(phrase);
    }
    if (regExpPosPosOrNegNeg.test(phrase)) {
        phrase.match(regExpPosPosOrNegNeg).forEach(phr => {
            phrase = phrase.replace(phr, '+');
        });
        return exports.solveSevralPositiveAndNegativeSings(phrase);
    }
    return phrase;
};
exports.solvePowerPhrases = (phrase) => {
    const powerPhrases = selectModules_1.selectPowerPhrase(phrase);
    if (!powerPhrases) {
        return phrase;
    }
    powerPhrases.forEach(phr => {
        const _result = exports.solvePowerPhrase(phr);
        phrase = phrase.replace(phr, _result);
    });
    return exports.solvePowerPhrases(phrase);
};
exports.solvePowerPhrase = (phrase) => {
    const powerPhrase = selectModules_1.selectLastPowerPhrase(phrase);
    if (!powerPhrase) {
        return phrase;
    }
    powerPhrase.forEach(phr => {
        const result = exports.solvePower(phr);
        phrase = phrase.replace(regulaExpersions_1.lastPowerRegExp, result);
    });
    return exports.solvePowerPhrase(phrase);
};
exports.solvePower = (phr) => {
    const numbers = selectModules_1.selectNumbers(phr);
    const num1 = +numbers[0];
    const num2 = +numbers[1];
    const result = Math.pow(num1, num2);
    return result > 0 ? `+${result}` : result.toString();
};
